import Vue from 'vue';
import { abilitiesPlugin } from '@casl/vue';
import store from '../vuex/store';

var ability = store.getters["auth/ability"]

Vue.use(abilitiesPlugin, ability, {
    useGlobalProperties: true
})